import styled from 'styled-components';

import { FunctionColor, Spacer } from '@lux/tokens';

export const Wrapper = styled.div`
    padding-bottom: ${Spacer.S};
    > ul {
        background-color: ${FunctionColor.function0};
    }
`;
